import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Valeria',
  city: 'Buenos Aires'
}, {
  name: 'Marina',
  city: 'Córdoba'
}, {
  name: 'Romina',
  city: 'Rosario'
}, {
  name: 'Carla',
  city: 'Mendoza'
}, {
  name: 'Julieta',
  city: 'Salta'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Luciana',
  city: 'La Plata'
}, {
  name: 'Camila',
  city: 'Mar del Plata'
}, {
  name: 'Elena',
  city: 'Santa Fe'
}, {
  name: 'Paula',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-2xl border border-slate-100 p-4 pr-8 flex items-center gap-4 max-w-[320px]" style={{
    animation: 'popup-in 0.4s ease-out forwards'
  }} data-id="element-262">
      <div className="bg-brand-primary/10 p-2 rounded-xl" data-id="element-263">
        <CheckCircle2 size={24} className="text-brand-primary" data-id="element-264" />
      </div>
      <div data-id="element-265">
        <p className="text-sm text-slate-800 leading-tight font-bold" data-id="element-266">
          {currentBuyer.name} de {currentBuyer.city}
        </p>
        <p className="text-xs text-slate-400 mt-1 font-medium" data-id="element-267">
          acaba de comprar este sistema
        </p>
      </div>
      <style data-id="element-268">{`
        @keyframes popup-in {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>;
}